const mediaItems = [
  {
    title: '《长安十二时辰》',
    subtitle: '古装悬疑 · 全48集',
    desc: '雷佳音、易烊千玺主演，大唐天宝年间长安城中一场惊天阴谋，画面精美如电影级别，剧情环环相扣。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20scene%20with%20elaborate%20traditional%20costumes%20and%20lantern-lit%20streets%20at%20night%2C%20mysterious%20atmosphere%2C%20rich%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20historical%20drama%20poster%20style%2C%20elegant%20and%20sophisticated&width=640&height=360&seq=media-card-01&orientation=landscape',
    tag: '热播',
    tagColor: 'bg-brand-500',
  },
  {
    title: '《流浪地球3》',
    subtitle: '科幻巨制 · HD1080P',
    desc: '吴京、刘德华领衔主演，人类命运面临终极考验，震撼视觉特效堪比好莱坞大片，国产科幻巅峰之作。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20massive%20spaceships%20flying%20through%20cosmic%20nebula%2C%20earth%20visible%20in%20background%2C%20dramatic%20blue%20and%20orange%20lighting%2C%20epic%20scale%2C%20cinematic%20movie%20poster%20style%2C%20grandiose%20space%20atmosphere&width=640&height=360&seq=media-card-02&orientation=landscape',
    tag: '新上线',
    tagColor: 'bg-green-500',
  },
  {
    title: '《乘风破浪的姐姐》',
    subtitle: '热门综艺 · 每周更新',
    desc: '实力女艺人集结，唱跳竞演精彩纷呈，舞台效果炸裂，姐姐们用实力证明年龄只是数字。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20performance%20with%20colorful%20spotlights%20and%20dynamic%20dancers%20on%20a%20grand%20stage%2C%20variety%20show%20atmosphere%2C%20energetic%20and%20glamorous%2C%20professional%20stage%20lighting%20with%20pink%20and%20purple%20tones%2C%20entertainment%20show%20poster%20style&width=640&height=360&seq=media-card-03&orientation=landscape',
    tag: '热播',
    tagColor: 'bg-brand-500',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">精彩推荐</h2>
            <p className="text-sm text-gray-500 mt-2">编辑精选，不容错过的热门内容</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {mediaItems.map((item, idx) => (
              <article key={idx} className="group bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-gray-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="relative aspect-video bg-gray-100 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <span className={`absolute top-3 left-3 ${item.tagColor} text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap`}>
                    {item.tag}
                  </span>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                      <i className="ri-play-fill text-brand-600 text-2xl w-6 h-6 flex items-center justify-center ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-gray-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-gray-400 mb-2">{item.subtitle}</p>
                  <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}